import React, { useEffect } from 'react'
import { userBridge, getUA } from '@penguin/utils'
import { STATS_MAP } from '@/utils'
import { getEncodeUserId } from '@/api'
import { replaceUrlParam } from '@/utils'
import classnames from 'classnames'
import qs from 'query-string'
import styles from './index.module.css'
const ua = getUA()

const LINK_MAP = {
  YD: {
    link: 'https://order.7islandstech.com/#/sim/cmcc?token=66227145020010&channelOrderId=01',
    img: '//static.qiekj.com/static/web/image/card-yd_1713420766709.png',
  },
  GD: {
    link: 'https://order.7islandstech.com/#/sim/cbn?token=66227145020043&channelOrderId=04',
    img: '//static.qiekj.com/static/web/image/card-gd_1713420766709.png',
  },
  LT: {
    link: 'https://order.7islandstech.com/#/sim/cucc?token=66227145020032&channelOrderId=03',
    img: '//static.qiekj.com/static/web/image/card-lt_1713420766709.png',
  },
  DX: {
    link: 'https://order.7islandstech.com/#/sim/ctcc?token=66227145020021&channelOrderId=02',
    img: '//static.qiekj.com/static/web/image/card-dx_1713420766709.png',
  },
}

const CardAd = () => {
  const { channel = '' } = qs.parse(location.search) as { channel: string }
  const isVip = channel === 'vip'
  useEffect(() => {
    window.aplus_queue.push({
      action: 'aplus.record',
      arguments: [
        STATS_MAP.cardAd.exposure,
        'CLK',
        {
          channel,
        },
      ],
    })
    userBridge('showOrHiddenStateBar', {
      isHidden: 1,
    })
    return () => {
      userBridge('showOrHiddenStateBar', {
        isHidden: 0,
      })
    }
  }, [])

  const jumpUrl = (url: string) => {
    if (ua === 'app') {
      userBridge('pushWindow', {
        url,
        closeCurrentWindow: false,
        closeAllWindow: false,
      })
    } else {
      window.location.href = url
    }
  }

  const goPage = async (type: keyof typeof LINK_MAP) => {
    let url = LINK_MAP[type].link
    window.aplus_queue.push({
      action: 'aplus.record',
      arguments: [
        STATS_MAP.cardAd.click,
        'CLK',
        {
          type,
          channel,
        },
      ],
    })
    if (isVip) {
      const res = await getEncodeUserId()
      url = replaceUrlParam(url, 'channelOrderId', encodeURIComponent(res || ''))
      jumpUrl(url)
      return
    }
    jumpUrl(url)
  }

  return (
    <div
      className={classnames(
        ' relative p-3 rem:pt-[44px] w-full pb-10',
        styles['card'],
        isVip && styles['card-vip'],
      )}
    >
      {ua === 'app' && (
        <img
          className=' w-6 h-6 fixed left-2'
          src='//static.qiekj.com/static/web/image/icon-left_1686626401509.png'
          alt=''
          onClick={() => userBridge('popWindow')}
        />
      )}
      <img
        className=' rem:mt-[150px]'
        src='//static.qiekj.com/static/web/image/card-progress_1713420766709.png'
        alt=''
      />
      {Object.keys(LINK_MAP).map((i: any) => {
        const item = LINK_MAP[i as keyof typeof LINK_MAP]
        return (
          <img
            onClick={() => goPage(i)}
            className=' rem:mt-[10px]'
            key={item.link}
            src={item.img}
          />
        )
      })}
      <img
        className=' rem:mt-[10px]'
        src={
          isVip
            ? '//static.qiekj.com/static/web/image/card-rule-vip_1714274297537.png'
            : '//static.qiekj.com/static/web/image/card-rule_1713420766709.png'
        }
        alt=''
      />
    </div>
  )
}

export default CardAd
